import "../styles/Ecosystem.scss";



const ecosystemArray = [
    {
        header: "Smart Animal",
        ribbion: "Smart Animal",
        class: "kids-hover",
        span: "span-daisi",
        description: 'Explore BlockStar Animals, where kids can embark on digital adventures for learning. Interactive stories and games ignite creativity in a safe online world. The ultimate fun destination for the youngest enthusiasts!',
        link: "https://blockstar.kids/",
        is_new: 2,
        link_type: 1
    }
];


export default function Kids() {
    return (
        <main>
            <article id="welcome" className="row">
                <div className="col">
                    <div className="social">
                        {ecosystemArray.map((item, index) => {
                            return (
                                <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    className={item.class}
                                    key={index}
                                >
                                    <div class="ribbon ribbon-top-left">
                                        <span className={item.span}>{item.ribbion}</span>
                                    </div>
                                    
                                    <p>{item.description}</p>
                                </a>
                            );
                        })}
                    </div>
                </div>
            </article>
        </main>
    )
}
